module.exports = __webpack_public_path__ + "static/media/tiempos-text-web-bold.cc7858c6.woff2";